const WATERMARK_SUPPORTED_EXTENSIONS = ['jpg', 'jpeg', 'png'];

const isWatermarkSupportedFormat = (fileExtension) => {
  const fileExtensionCheck = (fileExtension || '').toLowerCase();
  return WATERMARK_SUPPORTED_EXTENSIONS.includes(fileExtensionCheck);
};

export default isWatermarkSupportedFormat;
